import { Button, Col, Form, Input, Row, Select, Space } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { MitigationSectionProps } from ".";
import { ReportStatesEnum } from "../../../../../../constants/constants";
import i18n from "../../../../../../utils/i18n";
import { VALIDATION_UTIL } from "../../../../../../utils/validation.utils";
import { InfoCircleIcon } from "../../../../../atoms/icon";
import { AppSelect } from "../../../../../atoms/select";

const furtherRiskDropdow = [{
    value: true,
    name: i18n.t("ScenarioMitigation.lbYes")
}, {
    value: false,
    name: i18n.t("ScenarioMitigation.lbNo")
}]

const ResidualRickSection = (props: MitigationSectionProps) => {

    const { t } = useTranslation();
    const { data } = props;

    const gotoAppraisal = (state: ReportStatesEnum | undefined) => {
        if (props.gogoAppraisalTool) {
            props.gogoAppraisalTool(state);
        }
    }


    return (
        <div className="section-wrapper">
            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <AppSelect
                        placeholder={t("Global.plPleaseSelect")}
                        list={props.resources?.scenario_mitigation_resources?.control_effectiveness_types}
                        label={t("ScenarioMitigation.lbResidualRiskSeverity")}
                        name="residual_risk_severity_impact_control_effectiveness_type_id"
                        tooltip={{ title: t("ScenarioMitigation.lbResidualRiskSeverity"), icon: <InfoCircleIcon /> }}
                        rules={VALIDATION_UTIL.getRulesValidationField("residual_risk_severity_impact_control_effectiveness_type_id", props.requiredFields)}
                    />

                </Col>
            </Row>

            <Row>
                <Col span={24}>
                    <Form.Item
                        name="further_risk_reduction_required"
                        label={t("ScenarioMitigation.lbFurtherRisk")}
                        rules={VALIDATION_UTIL.getRulesValidationField("further_risk_reduction_required", props.requiredFields)}
                    >
                        <Select
                            placeholder={t("Global.plPleaseSelect")}>
                            {furtherRiskDropdow.map((item, index) => (
                                <Select.Option key={index} value={item.value.toString()}>
                                    {item.name}
                                </Select.Option>
                            ))}
                        </Select>

                    </Form.Item>
                </Col>
            </Row>

            <Row>
                <Col span={24}>
                    <Form.Item
                        label={t("ScenarioMitigation.lbFillProjectAppraisalForm")}
                        shouldUpdate={(prevValues, currentValues) => {
                            return prevValues.further_risk_reduction_required !== currentValues.further_risk_reduction_required
                        }}>
                        {({ getFieldValue }) =>
                            <Button type="primary" shape="round"
                             disabled={getFieldValue("further_risk_reduction_required") !== 'true'} 
                             onClick={()=> gotoAppraisal(props.data?.appraisal_tool?.submit_state)}>
                                {t("ScenarioMitigation.lbGoToForm")}
                            </Button>
                        }
                    </Form.Item>
                </Col>
            </Row>

            <Row>
                <Col span={24}>
                    <Form.Item
                        label={t("ScenarioMitigation.lbResidualRiskApprovedLevel")}>
                        <Space className="space-two">
                            <Input value={data?.residual_risk_severity_impact_control_effectiveness_type?.from_value} disabled={true} />
                            {t("ScenarioMitigation.lbTo")}
                            <Input value={data?.residual_risk_severity_impact_control_effectiveness_type?.to_value} disabled={true} />
                        </Space>

                    </Form.Item>
                </Col>
            </Row>

            <Row>
                <Col span={24}>
                    <Form.Item
                        name="actual_loss"
                        label={t("ScenarioMitigation.lbActualLoss")}
                        rules={VALIDATION_UTIL.getRulesValidationField("actual_loss", props.requiredFields)}
                    >
                        <Input />
                    </Form.Item>
                </Col>
            </Row>

        </div>
    )
}

export default ResidualRickSection;